var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var colors = ['bgColor', 'color', 'textColor'];
var fonts = ['fontSize', 'lineHeight', 'fontWeight'];
var borders = ['bRadius', 'bColor', 'bStyle', 'hasError', 'errorBColor'];
var sizes = [
    'width',
    'maxWidth',
    'minWidth',
    'height',
    'maxHeight',
    'minHeight',
];
var spacings = [
    'mTop',
    'mRight',
    'mBottom',
    'mLeft',
    'mx',
    'my',
    'pTop',
    'pRight',
    'pBottom',
    'pLeft',
    'px',
    'py',
];
var flexboxKeys = [
    'alignItems',
    'alignContent',
    'justifyItems',
    'justifyContent',
    'flexWrap',
    'flexDirection',
    'flex',
    'flexFlow',
    'flexGrow',
    'flexShrink',
    'flexBasis',
    'justifySelf',
    'alignSelf',
    'order',
    'placeItems',
    'placeContent',
    'placeSelf',
    'gap',
    'rowGap',
    'columnGap',
    'align',
    'basis',
    'flexDir',
    'grow',
    'justify',
    'shrink',
    'wrap',
];
var divKeys = [
    'display',
    'boxShadow',
    'boxSizing',
    'boxDecorationBreak',
    'overflow',
    'overflowY',
    'overflowX',
    'visibility',
    'float',
    'cursor',
];
var LAYOUT_KEYS = {
    divKeys: divKeys,
    flexboxKeys: flexboxKeys,
    borders: borders,
    spacings: spacings,
    sizes: sizes,
    colors: colors,
};
function getOnlyKeysProps(props, keys) {
    return Object.keys(props).reduce(function (acc, key) {
        keys.forEach(function (k) {
            if (key.includes(k)) {
                acc[k] = props[key];
            }
        });
        return acc;
    }, {});
}
var allAcceptableProps = Object.freeze({
    sizes: sizes,
    spacings: spacings,
    borders: borders,
    colors: colors,
    fonts: fonts,
});
var allAcceptableArrayProps = Object.keys(allAcceptableProps)
    .map(function (key) { return allAcceptableProps[key]; })
    .flat();
function sanitizeProps(_a) {
    var props = _a.props, acceptableProps = _a.acceptableProps, theme = _a.theme, _b = _a.defProps, defProps = _b === void 0 ? null : _b;
    if (!(acceptableProps === null || acceptableProps === void 0 ? void 0 : acceptableProps.length))
        return __assign(__assign({}, props), { theme: theme });
    var defaultProps = defProps ? defProps(theme) : {};
    var p = Object.keys(props).reduce(function (acc, key) {
        if (acceptableProps.includes(key)) {
            acc[key] = props[key];
        }
        return acc;
    }, defaultProps);
    return __assign(__assign({}, p), { theme: theme });
}
function transformKeyFromCSSInJSToCSS(key) {
    return key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function getCssProperties(props) {
    var css = '';
    Object.keys(props).forEach(function (key) {
        if (props[key]) {
            var cssKey = transformKeyFromCSSInJSToCSS(key);
            css += "".concat(cssKey, ": ").concat(props[key], "; ");
        }
    });
    return css;
}
export var Modifiers = Object.freeze({
    sanitizeProps: sanitizeProps,
    getOnlyKeysProps: getOnlyKeysProps,
    allAcceptableProps: allAcceptableProps,
    allAcceptableArrayProps: allAcceptableArrayProps,
    LAYOUT_KEYS: LAYOUT_KEYS,
    getCssProperties: getCssProperties,
    transformKeyFromCSSInJSToCSS: transformKeyFromCSSInJSToCSS,
});
